const IncomeGLCategoryTypes = {
  SR: 'Sales Revenue',
  RR: 'R&R Sales',
  RWA: 'Remove Weld & Align',
  RA: 'Repair Sales',
  PAINT: 'Painting Sales',
  FG: 'Fibre Glass Sales',
  CRUSH: 'Crush Sales',
  CD: 'Clean and Detail Sales',
  MECH: 'Mechanical Sales',
  PRT: 'Parts Sales',
  OPG: 'OPG Sales',
  MIS: 'Misc Sales',
  SUBL: 'Sublet Sales',
  ADJ: 'Excess',
  CADJ: 'Contrib',
  PDRI: 'PDR Items Sales',
  PDRR: 'PDR R&R Sales',
  TS: 'Towing Sales',
  DISC: 'Sales Discount',
  Other: 'Other Revenue'
}

const ExpenseGLCategoryTypes = {
  COS: 'Cost of Sales',
  GL_PU_ACC: 'Parts Supplies Expense',
  PE: 'Paint Supplies Expense',
  SSE: 'Sundry Supplies Expense',
  SCE: 'Sublet Costs',
  CMDE: 'Cost of Materials Depleted'
}

const AssetGLCategoryTypes = {
  MBA: 'Main Bank Account',
  UND: 'Un-Deposited Funds'
}

const OtherGLCategoryTypes = {
  AR: 'Accounts Receivables',
  AP: 'Accounts Payable',
  PROF: 'Retained Profits',
  GL_PU_ACC: 'Parts Expense'
}

const GSTGLCategoryTypes = {
  GST_COL: 'G/L Acct Collected',
  GST_SPENT: 'G/L Acct to be Refunded',
  TAXWH_ACC: 'G/L Acct With-held'
}

const PayrollGLCategoryTypes = {
  TAX_LIAB: 'PAYG Liability A/C',
  SUPER_LIAB: 'Superannuation Liability A/C',
  CS_LIAB: 'Child Support A/C'
}

export { IncomeGLCategoryTypes, ExpenseGLCategoryTypes, AssetGLCategoryTypes, OtherGLCategoryTypes, GSTGLCategoryTypes, PayrollGLCategoryTypes }
